export default "__VITE_ASSET__6c59c77f__"